import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from './UrgencyBar';
import { HeroSection } from './HeroSection';
import { HookSection } from './HookSection';
import { PainSection } from './PainSection';
import { RevelationSection } from './RevelationSection';
import { TestimonialsSection } from './TestimonialsSection';
import { BonusAntiCaosSection } from './BonusAntiCaosSection';
import { ValueStack } from './ValueStack';
import { TestimonialsPrePricing } from './TestimonialsPrePricing';
import { PricingSection } from './PricingSection';
import { FAQSection } from './FAQSection';
import { CommitmentSection } from './CommitmentSection';
import { Footer } from './Footer';
export function SalesPage() {
  useEffect(() => {
    document.title = 'El Escudo Hormonal 40+';
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = (window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', '1238986304986974');
    }
    ;
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-body text-brand-gray selection:bg-brand-gold/30 selection:text-brand-green" data-id="element-328">
      <UrgencyBar data-id="element-329" />
      <main data-id="element-330">
        <HeroSection data-id="element-331" />
        <HookSection data-id="element-332" />
        <PainSection data-id="element-333" />
        <RevelationSection data-id="element-334" />
        <TestimonialsSection data-id="element-335" />
        <ValueStack data-id="element-336" />
        <BonusAntiCaosSection data-id="element-337" />
        <TestimonialsPrePricing data-id="element-338" />
        <PricingSection data-id="element-339" />
        <FAQSection data-id="element-340" />
        <CommitmentSection data-id="element-341" />
      </main>

      <Footer data-id="element-342" />
    </div>;
}